/**
* jv.candidate.details.workflow.offerLetter.upload Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.offerLetter.upload.controller', [])
    .controller('jvCandidateDetailsWorkflowOfferLetterUpload', ['$scope', '$routeParams', 'candidates', '$location', '$rootScope','$window','jvHireUrlService',
        function($scope, $routeParams, candidates, $location, $rootScope,$window,jvHireUrlService){
            $scope.flags.loading = false;
            $scope.resumeuploader = {};

            $scope.checkEmptyObj = function(obj){
                if(obj){
                    return $.isEmptyObject(obj);
                }
            };

            var generatePdfVersion= function(fileId){
                candidates.viewOfferResource($routeParams.applicationId, fileId, 'readMode=0');
            };

            $scope.uploadOfferLetter= function(){
                var data = {};
                for(var x in $scope.resumeuploader){
                    data.fId = x;
                }
                data.isOffer = true;

                candidates.uploadOfferLetter($routeParams.applicationId, data, function(res){
                    generatePdfVersion(data.fId);
                    if(res.msgInfo === 200){
                        $rootScope.fastRead.uploadOffer = true;
                        jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                        $scope.showMsg('OFFER_LETTER_UPLOADED');
                        $scope.getApplicationDetails(true);
                    }else{
                        $scope.offerLetter = {
                            upload: {}
                        };

                        $scope.offerLetter.upload.error = true;
                    }
                });
            };
    }]);